"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class BadRequestError extends client_library_1.ExtendableError {
    constructor(field, message) {
        super(`${field} failed validation. ${message}`);
        this.field = field;
    }
}
exports.default = BadRequestError;
//# sourceMappingURL=BadRequestError.js.map